import React from "react";

export const VcbBotoSalePerformanceHeader = (props) => {
    return (
        <>
            <thead className={"bp-report-thead"}>
            <tr className={"bp-report-thead-tr"}>
                <th rowSpan={2} className={"bp-report-thead-th"}>Cây báo cáo</th>
                <th rowSpan={2} className={"bp-report-thead-th"}>Phân Loại</th>
                <th colSpan={4} className={"bp-report-thead-th"}>LEAD</th>
                <th colSpan={3} className={"bp-report-thead-th"}>Ngày: {props?.inputDay}</th>
                <th colSpan={5} className={"bp-report-thead-th"}>Tích Lũy Tháng</th>
                <th colSpan={5} className={"bp-report-thead-th"}>Tích Lũy Quý</th>
                <th colSpan={6} className={"bp-report-thead-th"}>Tích Lũy Năm</th>
                <th rowSpan={2} className={"bp-report-thead-th"}>IP Pending</th>
                <th rowSpan={2} className={"bp-report-thead-th"}>Case NET</th>
                <th colSpan={3} className={"bp-report-thead-th"}>Tỷ lệ Active POS theo CN</th>
                <th colSpan={5} className={"bp-report-thead-th"}>Tỷ lệ active LLBH</th>
                <th colSpan={3} className={"bp-report-thead-th"}>NSLĐ của CBBH</th>
            </tr>

            <tr className={"bp-report-thead-tr"}>
                <th>KH Lead</th>
                <th>Lead Được Tạo</th>
                <th>% HTKH Lead</th>
                <th>Tỷ lệ chuyển đổi</th>
                <th>Mô Hình Giới Thiệu</th>
                <th>Mô Hình Online</th>
                <th>Bảo Hiểm Tín Dụng</th>
                <th>Mô Hình Giới Thiệu</th>
                <th>Mô Hình Online</th>
                <th>Bảo Hiểm Tín Dụng</th>
                <th>Tất cả</th>
                <th>% HTKH Tháng</th>
                <th>Mô Hình Giới Thiệu</th>
                <th>Mô Hình Online</th>
                <th>Bảo Hiểm Tín Dụng</th>
                <th>Tất Cả (Bao gồm kết chuyển)</th>
                <th>% HTKH Quý</th>
                <th>Mô Hình Giới Thiệu</th>
                <th>Mô Hình Online</th>
                <th>Bảo Hiểm Tín Dụng</th>
                <th>Kết Chuyển</th>
                <th>Tất Cả (Bao gồm kết chuyển)</th>
                <th>% HTKH Năm</th>
                <th>SL POS</th>
                <th>POS Active</th>
                <th>Tỷ lệ POS active</th>
                <th>Số lượng CBBH</th>
                <th>Số lượng CBBH có code</th>
                <th>% CBBH có code</th>
                <th>CBBH Active</th>
                <th>Tỷ lệ CBBH Active</th>
                <th>FYP/CBBH active</th>
                <th>Số lượng HĐ/CBBH active</th>
                <th>Case size</th>
            </tr>
            </thead>
        </>
    )
}

export default VcbBotoSalePerformanceHeader;